module.exports = __webpack_public_path__ + "img/resize-icon-bl.452157b3.svg";